// Add-from-a-list, used for followers and CCs.
//
// A native <select> rather than a custom multi-select: it is one tab stop, opens
// on any keyboard, and type-to-jump already works in it. On a screen measured in
// seconds per call, the built-in control wins.
//
// The chosen chips reuse `.badge` for its shape only and take the neutral surface
// tokens (bg-sunken / text-ink-secondary / ring-line-strong) rather than one of the
// `badge-*` hues: those encode ticket status and must keep meaning that everywhere.

export default function ChipSelect({ id, label, hint, options, value, onChange, placeholder }) {
  const chosen = options.filter((option) => value.includes(option.id));
  const available = options.filter((option) => !value.includes(option.id));

  return (
    <div>
      <label className="field-label" htmlFor={id}>{label}</label>
      {chosen.length > 0 && (
        <ul className="mb-1 flex flex-wrap gap-1">
          {chosen.map((option) => (
            <li key={option.id} className="badge bg-sunken text-ink-secondary ring-line-strong">
              {option.label}
              <button
                type="button"
                className="text-ink-muted hover:text-ink"
                aria-label={`Remove ${option.label}`}
                onClick={() => onChange(value.filter((entry) => entry !== option.id))}
              >
                ×
              </button>
            </li>
          ))}
        </ul>
      )}
      <select
        id={id}
        className="field-input"
        value=""
        onChange={(event) => {
          if (!event.target.value) return;
          onChange([...value, event.target.value]);
        }}
      >
        <option value="">{placeholder}</option>
        {available.map((option) => (
          <option key={option.id} value={option.id}>
            {option.hint ? `${option.label}: ${option.hint}` : option.label}
          </option>
        ))}
      </select>
      {hint && <p className="mt-1 text-xs text-ink-muted">{hint}</p>}
    </div>
  );
}
